import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import {
  StepperWrapper,
  ValueDisplay,
  SpinnerWrapper,
  StepperButton,
  StepperArrow
} from './styles/NumericStepper.styles';

const NumericStepperControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <StepperWrapper
      styleProps={control.attributes}
      renderMode={renderMode}
      height={control.height}
    >
      <ValueDisplay styleProps={control.attributes}>{control.defaultValue}</ValueDisplay>
      <SpinnerWrapper>
        <StepperButton>
          <StepperArrow direction="up" styleProps={control.attributes} />
        </StepperButton>
        <StepperButton>
          <StepperArrow direction="down" styleProps={control.attributes} />
        </StepperButton>
      </SpinnerWrapper>
    </StepperWrapper>
  </ObjectWrapper>
);

export default NumericStepperControl;